export default "__VITE_ASSET__CS42TrOD__"